export default "__VITE_ASSET__CW349NlN__"